import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import useCommissionStructure from "./hooks/useCommissionStructure";
import Paginations from "../../../Components/Pagination/pagination";
import { Modal } from "react-bootstrap";
import { useState } from "react";

const CommissionStructure = () => {
  const navigate = useNavigate();
  //    const {STRUCTURE_ID} = useParams()
  // console.log(STRUCTURE_ID, 'STRUCTURE_ID')

  const { data, method } = useCommissionStructure();
  const { commissionList, count, page, PER_PAGE } = data;
  const { commissionDelete, setPage } = method;
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
  };

  return (
    <div>
      <ToastContainer />
      <section>
        {/* {spinner && <Spinner />} */}
        <div className="m-t-3 cus-padd cusheight">
          <div className="d-flex w-full justify-content-between border-bottom pb-3">
            <div className="d-flex flex-column flex-md-row justify-content-between">
              <h2 className="page-tittle mb-2 mb-md-0">
                <i
                  className="fa-solid fa-angle-left cusgap cursor me-2"
                  onClick={() => navigate(-1)}
                ></i>
                Commission Structure
              </h2>
            </div>
            <hr />

            {/* <Button
              onClick={() =>
                navigate("/layout/setting/commission-structure/add")
              }
              variant="contained"
              startIcon={<AddIcon />}
              style={{
                background: "#EB9283",
                borderRadius: "10px",
                padding: "10px",
              }}
            >
              Add Structure
            </Button> */}
            <button
              onClick={() =>
                navigate("/layout/setting/commission-structure/add")
              }
              className="btn px-4"
              style={{
                background: "linear-gradient(to right, #EA8F80, #F09A8B)",
                color: "#FFF",
                border: "none",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500",
                paddingBlock: "12px",
              }}
            >
              <AddIcon /> Add Structure
            </button>
          </div>

          <div className="d-flex flex-column gap-3 pt-4">
            {commissionList.map((item) => (
              <div
                key={item._id}
                className="d-flex justify-content-between align-items-start"
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  padding: "16px 18px",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                }}
              >
                {/* Left Content */}
                <div>
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <span
                      style={{ margin: 0, fontWeight: 600, fontSize: "15px" }}
                    >
                      {item?.structureName}
                    </span>

                    <span
                      style={{
                        fontSize: "11px",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        background:
                          item.modelType === "TARGET_BASED"
                            ? "#EAF1FF"
                            : "#F3E8FF",
                        color:
                          item.modelType === "TARGET_BASED"
                            ? "#2563EB"
                            : "#7C3AED",
                        fontWeight: 500,
                      }}
                    >
                      {item.modelType === "TARGET_BASED"
                        ? "Target Based"
                        : "Item Based"}
                    </span>
                  </div>

                  <p
                    style={{
                      margin: "4px 0",
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    Assigned to: {item?.assignTo}
                  </p>

                  {(item.validFrom || item.validTo) && (
                    <p
                      style={{
                        margin: 0,
                        fontSize: "13px",
                        color: "#777",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <i className="fa-regular fa-calendar" />
                      Validity:
                      {item?.validFrom && ` From ${formatDate(item.validFrom)}`}
                      {item?.validTo && ` to ${formatDate(item.validTo)}`}
                    </p>
                  )}
                </div>

                {/* Actions */}
                <div className="d-flex gap-2">
                  <button
                    onClick={() =>
                      navigate(
                        `/layout/setting/commission-structure/update/${item._id}`
                      )
                    }
                    type="button"
                    style={{
                      color: "#666",
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                      padding: "4px",
                    }}
                  >
                    <FiEdit />
                  </button>

                  <button
                    onClick={() => {
                      setDeleteId(item?._id);
                      setShowDelete(true);
                    }}
                    type="button"
                    style={{
                      color: "#DC3545",
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                      padding: "4px",
                    }}
                  >
                    <RiDeleteBin5Line fontSize={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="w-100 d-flex justify-content-center mt-3">
            {commissionList.length === 0
              ? null
              : count > 10 && (
                  <Paginations
                    setpage={setPage}
                    count={Math.ceil(count / PER_PAGE)}
                    page={page}
                  />
                )}
          </div>
        </div>
      </section>
      <Modal
        centered
        size="sm"
        show={showDelete}
        onHide={() => setShowDelete(false)}
      >
        <div className="modal-content">
          <div className="modal-body text-center">
            <p>Are you sure?</p>
            <p>You want to delete this Commission</p>
            <button
              type="button"
              className="btn  nobtn"
              onClick={() => {
                commissionDelete(deleteId);
                setShowDelete(false);
                setDeleteId(null);
              }}
            >
              Yes
            </button>

            <button
              type="button"
              className="btn ms-1  yesbtn"
              onClick={() => {
                setShowDelete(false);
                setDeleteId(null);
              }}
            >
              No
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CommissionStructure;
